<template>
  <div class="md:flex bg-gray-100 px-8 py-2">
    <div class="flex items-center text-xs">
      <span>
        <router-link :to="homeRouter">
          <svg xmlns="http://www.w3.org/2000/svg" width="12.071" height="14" viewBox="0 0 12.071 14">
            <path
              id="Path_2438"
              data-name="Path 2438"
              d="M499.691,294.451c-.175-.135-5.014-2.826-5.014-2.826a.83.83,0,0,0-1.019.008L488.81,294.4c-.388.275-.694.412-.694.916v9.645a.5.5,0,0,0,.5.5h3.365v-4.943h4.348v4.943h3.365a.5.5,0,0,0,.5-.5v-9.645C500.187,294.839,500.042,294.723,499.691,294.451Z"
              transform="translate(-488.116 -291.455)"
              fill="#bababa"
            />
          </svg>
        </router-link>
      </span>
      <span class="separate mx-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10.738" viewBox="0 0 6 10.738">
          <path
            id="Path_2436"
            data-name="Path 2436"
            d="M5.933,10.061,1.24,5.36,5.919.69,5.948.641a.5.5,0,0,0-.107-.51A.452.452,0,0,0,5.329.043L.129,5.231,0,5.36l5.293,5.3.043.028a.608.608,0,0,0,.232.048.411.411,0,0,0,.33-.148A.473.473,0,0,0,5.933,10.061Z"
            transform="translate(6 10.738) rotate(180)"
            fill="#ccc"
          />
        </svg>
      </span>
      <template v-for="(item, index) in breadcrumb">
        <span v-if="item.active" :key="'text_' + index" class="item">
          {{ item.text }}
        </span>
        <router-link v-else :key="'link_' + index" :to="item.href" class="item underline">
          {{ item.text }}
        </router-link>
        <span v-if="index < breadcrumb.length - 1" :key="'icon_' + index" class="separate my-0 md:mx-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10.738" viewBox="0 0 6 10.738">
            <path
              id="Path_2436"
              data-name="Path 2436"
              d="M5.933,10.061,1.24,5.36,5.919.69,5.948.641a.5.5,0,0,0-.107-.51A.452.452,0,0,0,5.329.043L.129,5.231,0,5.36l5.293,5.3.043.028a.608.608,0,0,0,.232.048.411.411,0,0,0,.33-.148A.473.473,0,0,0,5.933,10.061Z"
              transform="translate(6 10.738) rotate(180)"
              fill="#ccc"
            />
          </svg>
        </span>
      </template>
    </div>
    <transition name="fade">
      <div v-if="toastMessage" :class="toastClass" @click="removeToast">
        {{ toastMessage }}
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Breadcrumb',
  computed: {
    ...mapGetters(['toastMessage', 'isNegativeToastMessage', 'breadcrumb', 'profile']),
    toastClass() {
      return (
        'fixed w-72 toast-bg-color rounded-sm right-0 left-0 mx-auto shadow-md text-white text-sm py-1 px-5 cursor-pointer z-20 animation-response' +
        (this.isNegativeToastMessage ? ' negative-toast' : '')
      )
    },
    homeRouter() {
      if (this.profile?.member_info?.role_id === this.$constantGenerate.Member.ROLE_USER) {
        return { name: 'fcs.members.list' }
      }
      if (this.profile?.member_info?.role_id === this.$constantGenerate.Member.ROLE_OPERATOR) {
        return { name: 'fcs.organizations' }
      }
      return { name: 'fcs.members.list' }
    },
  },
  watch: {
    toastMessage(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.removeToast()
        }, 5000)
      }
    },
  },
  methods: {
    removeToast() {
      this.$store.commit('commonStore/RESET_TOAST_MESSAGE')
      this.$store.commit('commonStore/RESET_IS_NEGATIVE_TOAST_MESSAGE')
    },
  },
}
</script>

<style scoped>
.separate {
  color: #ccc;
}
.item {
  color: #999;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.negative-toast {
  background-color: #de5510;
}

/* prevent toast message displays twice */
/*.animation-response {*/
/*  animation: signup-response 0.5s 1;*/
/*  -webkit-animation: signup-response 0.5s 1;*/
/*  animation-fill-mode: forwards;*/

/*  animation-delay: 5s;*/
/*  -webkit-animation-delay: 5s;*/
/*  -webkit-animation-fill-mode: forwards;*/
/*}*/

@keyframes signup-response {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@-webkit-keyframes signup-response {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.animation-delay {
  animation-delay: 5s;
}
</style>
